import { useState } from "react"
import { Button, Form } from "react-bootstrap"
import DeleteConfirm from "../forms/DeleteConfirm"
import NavigateButton from "./NavigateButton"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import PermissionContainer from '../../../Hocs/withPermission';

const SaveDeleteButtons = ({
	saveClick,
	deleteClick,
	voltarClick,
	deleteConfirmMsg,
	saveLabel,
	deleteLable,
	voltarLabel,
	cancelEditClick,
	isEditing,
	disabled,
	copyForm,
	deleteId,
}) => {
	const [show, setShow] = useState()
	const dispatch = useDispatch()
	const context = useSelector((state) => state.global.context)
	const navigate = useNavigate()

	const onDeleteClick = () => {
		setShow(true)
	}

	const cancelDelete = () => {
		setShow(false)
	}

	const cancelEditionClick = () => {
		if (cancelEditClick) cancelEditClick()
		else dispatch({ type: `${context}Reducer/clear` })
	}
	const copyFormHandler = () => {
		const genericCopy = {
			...copyForm,
			id: null,
			createdAt: null,
			updatedAt: null,
		}
		dispatch({
			type: `${context}Reducer/populateToEdit`,
			payload: genericCopy,
		})
	}

	return (
		<>
			<DeleteConfirm
				dialogText={
					deleteConfirmMsg ||
					"Voce tem certeza que deseja seguir com essa operação"
				}
				closeCredentialConfirm={cancelDelete}
				show={show}
				title={`Excluindo ${context}`}
				onConfirm={deleteClick}
				confirmCancel={cancelDelete}
				showDeleteConfirm={() => setShow()}
			></DeleteConfirm>
			<Form.Group style={{ marginTop: 8 }}>
				{voltarClick && (
					<NavigateButton
						voltarCallback={voltarClick}

						displayName={voltarLabel || "Voltar"}
					/>
				)}
				{isEditing && (
					<Button
						style={{ margin: 2 }}
						variant="warning"
						type="reset"
						onClick={cancelEditionClick}
					>
						{"Cancelar"}
					</Button>
				)}
				<PermissionContainer
					component={(componenteRef) => {
						return (
							isEditing && deleteClick && (
								<Button
									id={deleteId}
									style={{ margin: 2 }}
									variant="danger"
									type="reset"
									ref={componenteRef}
									onClick={() => onDeleteClick()}
								>
									{deleteLable || "Excluir"}
								</Button>
							)
						)
					}}
				/>
				{saveClick && (
					<Button
						disabled={disabled || false}
						style={{ margin: 2 }}
						type="reset"
						onClick={() => saveClick()}
					>
						{saveLabel || "Salvar"}
					</Button>
				)}
				{isEditing && copyForm && (
					<Button
						style={{ margin: 2 }}
						variant="secondary"
						onClick={() => copyFormHandler()}
					>
						{"Copiar Formulário"}
					</Button>
				)}
			</Form.Group>
		</>
	)
}

export default SaveDeleteButtons
